export default "<app-repository-policy-documents-form></app-repository-policy-documents-form>\n";